import React, { useState } from "react";
import Image from "next/image";
import { configApi } from "@shared/lib/configApi";
import { RouterSlugs } from "@shared/lib/routerSlugs";
import { PopularBrands } from "./config";
import { BrandsListLabels, ITEMS_QNT_SHORT_MODE } from "./constants";
import classes from "./BrandsList.module.scss";

const BrandsList = () => {
    const [isShortMode, setIsShortMode] = useState(true);

    const toggleMode = (e: React.MouseEvent) => {
        e.preventDefault();
        setIsShortMode(!isShortMode);
    };

    const data = isShortMode ? PopularBrands.slice(0, ITEMS_QNT_SHORT_MODE) : PopularBrands;

    return (
        <div className={classes.BrandsList}>
            <ul className={classes.BrandsList__inner}>
                {data.map((el) => {
                    const logoUrl = `${configApi.YANDEX_STORAGE_URL}/logos/${el.alias}.webp`;
                    return (
                        <li className={classes.BrandsList__item} key={el.name}>
                            <a
                                className={classes["BrandsList__item-link"]}
                                href={`/catalog/${RouterSlugs.SLUG_ALL_CITIES}/${encodeURIComponent(el.alias)}/${RouterSlugs.SLUG_FILTERS_END}`}
                                aria-label={`Перейти к объявлениям ${el.name}`}
                            >
                                <Image
                                    src={logoUrl}
                                    alt={`Логотип бренда ${el.name}`}
                                    width={36}
                                    height={36}
                                    unoptimized={true}
                                    onError={(e) => {
                                        e.currentTarget.src = "/img/placeholder-brand.png";
                                        e.currentTarget.srcset = "/img/placeholder-brand.png";
                                    }}
                                />
                                <span className={classes["BrandsList__item-label"]}>{el.name}</span>
                            </a>
                        </li>
                    );
                })}
            </ul>
            <a className={classes.BrandsList__toggler} onClick={toggleMode} href="#">
                {isShortMode ? BrandsListLabels.SHOW_ALL_LABEL : BrandsListLabels.SHOW_LESS_LABEL}
            </a>
        </div>
    );
};

export default BrandsList;